/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react'
import { Box, Button, ButtonProps, styled, SxProps, Typography } from '@mui/material'

// ICON
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import SearchIcon from '@mui/icons-material/Search';
// import { icons } from '../../assets/icons/icons';
import { colors } from '../../constants/colors';
import SaveIcon from '@mui/icons-material/Save';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { useDropzone } from 'react-dropzone';
import { IconComponent } from '../../assets/icons/iconComponent';
import LanguageIcon from '@mui/icons-material/Language';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';


export type ButtonType = {
    NEXT: "NEXT",
    SEARCH: "SEARCH",
    BACK: "BACK",
    ADD: "ADD",
    ADD2: "ADD2",
    SEND: "SEND",
    IMPORT_EXCEL: "IMPORT_EXCEL",
    SAVE_DRAFT: "SAVE_DRAFT",
    SAVE: "SAVE",
    CANCEL: "CANCEL",
    CONFIRM: "CONFIRM",
    DOWNLOAD_CSV: "DOWNLOAD_CSV",
    DOWNLOAD_PDF: "DOWNLOAD_PDF",
    APPROVE: "APPROVE",
    APPROVE2: "APPROVE2",
    REJECT: "REJECT",
    TIMELINE: "TIMELINE",
    MEETING: "MEETING",
    RETURN: "RETURN",
    PUBLISH: "PUBLISH",
    DELETE_BIN: "DELETE_BIN",
    EDIT: "EDIT"
    NONE: "NONE"
}
export type ButtonCustomProps = {
    buttonData: {
        ref?: any,
        key: string,
        label: string,
        type: keyof ButtonType,
        seq: number;
        buttonProps: ButtonProps,
        enableEndIcon?: boolean;
        hidden?: boolean;
        fullWidth?: boolean;
        disabledTemplateBorder?: boolean;
        disabledTemplateBackground?: boolean;
        disabledTemplateColor?: boolean;
        disabledPadding?: boolean;
        startIcon?: React.ReactNode;
        endIcon?: React.ReactNode;
        onFileChange?: (file: any) => void;
        width?: string;
        maxWidth?: string;
    }[];
    justifyContent?: React.CSSProperties['justifyContent'];
    alignItems?: React.CSSProperties['alignItems'];
    otherProps?: { spacing: number }
    sxContainer?: SxProps;
    className?: string;
    multiple_upload_file?: boolean;
    enable_image?: boolean;
    enable_pdf?: boolean;
}

const ButtonLayout = styled(Button)({
    width: "100%",
    borderRadius: "8px",
    '&:disabled': {
        backgroundColor: colors.disabledGray,
        opacity: .4,
        border: "none",
        color: "rgba(0,0,0,0.8) !important"
    },
    '&:disabled > p': {
        backgroundColor: colors.disabledGray,
        opacity: .4,
        border: "none",
        color: "rgba(0,0,0,0.8) !important"
    }
})

const ContainerButton: React.FC<ButtonCustomProps> = (props: ButtonCustomProps) => {
    const renderIcons = (type: keyof ButtonType): React.ReactNode => {
        let icon = <></>;
        switch (type) {
            case 'NEXT': {
                icon = <ArrowForwardIosIcon sx={{ color: colors.white }} />;
                break;
            }
            case 'SEARCH': {
                icon = <SearchIcon sx={{ color: colors.white }} />;
                break;
            }
            case 'BACK': {
                icon = <ArrowBackIosIcon sx={{ color: colors.textNormal }} />;
                break;
            }
            case 'ADD': {
                icon = <IconComponent.AddIcon />
                break;
            }
            case 'ADD2': {
                icon = <IconComponent.AddIcon />
                break;
            }
            case 'PUBLISH': {
                icon = <LanguageIcon sx={{ color: "white" }} />
                break;
            }
            case 'SEND': {
                icon = <IconComponent.SendIcon />
                break;
            }
            case 'TIMELINE': {
                icon = <IconComponent.ClockIcon />
                break;
            }
            case 'SAVE_DRAFT': {
                icon = <IconComponent.SaveDraftIcon />
                break;
            }
            case 'SAVE': {
                icon = <SaveOutlinedIcon sx={{ color: 'white' }} />
                break;
            }
            case 'RETURN': {
                icon = <IconComponent.ReturnIcon />
                break;
            }
            case 'APPROVE': {
                icon = <IconComponent.ApproveCheckIcon />
                break;
            }
            case 'APPROVE2': {
                icon = <IconComponent.ApproveCheckIcon />
                break;
            }
            case 'REJECT': {
                icon = <IconComponent.RejectCheckIcon />
                break;
            }
            case 'MEETING': {
                icon = <IconComponent.MeetingIcon />
                break;
            }
            case 'DOWNLOAD_CSV': {
                icon = <IconComponent.CSVIcon />
                break;
            }
            case 'DOWNLOAD_PDF': {
                icon = <IconComponent.PdfIcon />
                break;
            }
            default: {
                icon = <></>
                break;
            }
        }

        return icon;
    }

    const renderPattern = (type: keyof ButtonType) => {
        const renderColor = (): string => {
            let color: string = '';
            switch (type) {
                case 'NEXT': {
                    color = colors.white;
                    break;
                }
                case 'SEARCH': {
                    color = colors.white;
                    break;
                }
                case 'BACK': {
                    color = colors.textNormal
                    break;
                }
                case 'ADD': {
                    color = colors.white;
                    break;
                }
                case 'ADD2': {
                    color = colors.white;
                    break;
                }
                case 'PUBLISH': {
                    color = colors.white;
                    break;
                }
                case 'SEND': {
                    color = colors.white;
                    break;
                }
                case 'CONFIRM': {
                    color = colors.white;
                    break;
                }
                case 'RETURN': {
                    color = colors.white;
                    break;
                }
                case 'SAVE_DRAFT': {
                    color = colors.white;
                    break;
                }
                case 'MEETING': {
                    color = colors.white;
                    break;
                }
                case 'TIMELINE': {
                    color = colors.white;
                    break;
                }
                case 'REJECT': {
                    color = colors.white;
                    break;
                }
                case 'DOWNLOAD_CSV': {
                    color = colors.white;
                    break;
                }
                case 'DOWNLOAD_PDF': {
                    color = colors.white;
                    break;
                }
                case 'APPROVE': {
                    color = colors.white;
                    break;
                }
                case 'APPROVE2': {
                    color = colors.white;
                    break;
                }
                case 'SAVE': {
                    color = colors.white;
                    break;
                }
                case 'EDIT': {
                    color = colors.white;
                    break;
                }
                case 'CANCEL': {
                    color = colors.black;
                    break;
                }
                case 'NONE': {
                    color = colors.white;
                    break;
                }
                default: {
                    color = colors.black
                }
            }
            return color;
        }
        const renderBackgroundColor = (): string => {
            let bgColor: string = '';
            switch (type) {
                case 'NEXT': {
                    bgColor = colors.blue;
                    break;
                }
                case 'SEARCH': {
                    bgColor = colors.themeMainColor;
                    break;
                }
                case 'BACK': {
                    bgColor = colors.white
                    break;
                }
                case 'ADD': {
                    bgColor = colors.themeMainColor;
                    break;
                }
                case 'ADD2': {
                    bgColor = colors.success3;
                    break;
                }
                case 'SEND': {
                    bgColor = colors.success3;
                    break;
                }
                case 'SAVE_DRAFT': {
                    bgColor = colors.blueDraft;
                    break;
                }
                case 'MEETING': {
                    bgColor = colors.blueDraft;
                    break;
                }
                case 'PUBLISH': {
                    bgColor = colors.blueDraft;
                    break;
                }
                case 'DOWNLOAD_CSV': {
                    bgColor = colors.csv;
                    break;
                }
                case 'DOWNLOAD_PDF': {
                    bgColor = colors.red;
                    break;
                }
                case 'CONFIRM': {
                    bgColor = colors.success3;
                    break;
                }
                case 'EDIT': {
                    bgColor = "#F79009";
                    break;
                }
                case 'APPROVE': {
                    bgColor = colors.success3;
                    break;
                }
                case 'NONE': {
                    bgColor = colors.success3;
                    break;
                }
                case 'TIMELINE': {
                    bgColor = colors.themeSecondColor;
                    break;
                }
                case 'RETURN': {
                    bgColor = colors.themeSecondColor;
                    break;
                }
                case 'SAVE': {
                    bgColor = colors.success3;
                    break;
                }
                case 'REJECT': {
                    bgColor = colors.reject;
                    break;
                }
                case 'CANCEL': {
                    bgColor = colors.white;
                    break;
                }
                case 'APPROVE2': {
                    bgColor = colors.blue;
                    break;
                }
                default: {
                    bgColor = "#fefefefe"
                }
            }
            return bgColor;
        }
        const renderBorder = (): string => {
            let border: string = '';
            switch (type) {
                case 'NEXT': {
                    border = '1px solid #0075CB';
                    break;
                }
                case 'SEARCH': {
                    border = '1px solid #0075CB';
                    break;
                }
                case 'BACK': {
                    border = `1px solid ${colors.textNormal}`;
                    break;
                }
                case 'ADD': {
                    border = `1px solid ${colors.themeMainColor}`;
                    break;
                }
                case 'ADD2': {
                    border = `1px solid ${colors.success3}`;
                    break;
                }
                case 'EDIT': {
                    border = "1px solid #F79009";
                    break;
                }
                case 'SEND': {
                    border = `1px solid ${colors.success3}`;
                    break;
                }
                case 'APPROVE': {
                    border = `1px solid ${colors.success3}`;
                    break;
                }
                case 'APPROVE2': {
                    border = `1px solid ${colors.blue}`;
                    break;
                }
                case 'NONE': {
                    border = `1px solid ${colors.success3}`;
                    break;
                }
                case 'REJECT': {
                    border = `1px solid ${colors.reject}`;
                    break;
                }
                case 'TIMELINE': {
                    border = `1px solid ${colors.themeSecondColor}`;
                    break;
                }
                case 'RETURN': {
                    border = `1px solid ${colors.themeSecondColor}`;
                    break;
                }
                case 'DOWNLOAD_CSV': {
                    border = `1px solid ${colors.csv}`;
                    break;
                }
                case 'DOWNLOAD_PDF': {
                    border = `1px solid ${colors.red}`;
                    break;
                }
                case 'CONFIRM': {
                    border = `1px solid ${colors.success3}`;
                    break;
                }
                case 'SAVE': {
                    border = `1px solid ${colors.success3}`;
                    break;
                }
                case 'CONFIRM': {
                    border = `1px solid ${colors.success3}`;
                    break;
                }
                case 'SAVE_DRAFT': {
                    border = `1px solid ${colors.blueDraft}`;
                    break;
                }
                case 'PUBLISH': {
                    border = `1px solid ${colors.blueDraft}`;
                    break;
                }
                case 'MEETING': {
                    border = `1px solid ${colors.blueDraft}`;
                    break;
                }
                default: {
                    border = "1px solid #000000"
                }
            }
            return border
        }
        return {
            renderColor,
            renderBackgroundColor,
            renderBorder
        }
    }
    const onDrop = useCallback((acceptedFiles: any) => {
        const file = acceptedFiles[0];

        if (props.multiple_upload_file) {
            const buttonItem = props.buttonData.find((item) => item.type === 'IMPORT_EXCEL');
            if (buttonItem && buttonItem.onFileChange) {
                return buttonItem.onFileChange(acceptedFiles);
            }
        }
        if (file) {
            const buttonItem = props.buttonData.find((item) => item.type === 'IMPORT_EXCEL');
            if (buttonItem && buttonItem.onFileChange) {
                buttonItem.onFileChange(file);
            }
        }
    }, [props.buttonData]);
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        maxFiles: props.multiple_upload_file ? 1000 : 1,
        ...(props.enable_pdf ? {
            accept: {
                'application/pdf': ['.pdf'],
            }
        } : props.enable_image ? {
            accept: {
                'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.webp'],
            }
        } : {
            accept: {
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
                'application/vnd.ms-excel': ['.xls'],
            }
        })
    })

    return (
        <Box sx={{ width: "100%", height: "fit-content", ...props.sxContainer }}>
            <div style={{ justifyContent: props.justifyContent || "center", alignItems: props.alignItems || 'center' }} className={`h-full flex flex-col md:flex-row gap-4 ${props.className}`}>
                {
                    props.buttonData.filter((x) => !x.hidden).sort((x, y) => x.seq - y.seq).map((list, i) => {
                        return (
                            <span className={`h-full max-h-[45px] ${list.fullWidth && 'w-full'}`} key={list.key}>
                                {list.type === 'IMPORT_EXCEL' ? (
                                    <ButtonLayout
                                        ref={list.ref}
                                        {...getRootProps()}
                                        {...list.buttonProps}
                                        {...(list.enableEndIcon ? {
                                            endIcon: renderIcons(list.type)
                                        } : {
                                            startIcon: list.startIcon ? list.startIcon : renderIcons(list.type)
                                        })}
                                        sx={{
                                            cursor: "pointer",
                                            ':hover': {
                                                opacity: .8,
                                            },
                                            px: list.disabledPadding ? undefined : 2,
                                            textTransform: "none",
                                            height: '100%',
                                            transition: "all .5 ease",
                                            boxShadow: !list.disabledTemplateBackground ? "0px 1px 3px 1px rgba(0,0,0,.10)" : undefined,
                                            backgroundColor: !list.disabledTemplateBackground ? renderPattern(list.type).renderBackgroundColor() : undefined,
                                            border: !list.disabledTemplateBorder ? renderPattern(list.type).renderBorder() : undefined,

                                        }}
                                    >
                                        <label className='cursor-pointer' htmlFor={`import-file-excel-${i}`}>
                                            <Typography sx={{
                                                fontSize: "16px",
                                                color: !list.disabledTemplateColor ? renderPattern(list.type).renderColor() : undefined,
                                            }} >
                                                {list.label}
                                            </Typography>
                                        </label>
                                        <input  {...getInputProps()} multiple={props.multiple_upload_file || false} {...(!(props.enable_pdf || props.enable_image) && {
                                            accept: '.xlsx,.xls',
                                        })} className='hidden' />
                                    </ButtonLayout>
                                ) : (
                                    <ButtonLayout
                                        {...list.buttonProps}
                                        {...(list.enableEndIcon ? {
                                            endIcon: list.endIcon ? list.endIcon : renderIcons(list.type)
                                        } : {
                                            startIcon: list.startIcon ? list.startIcon : renderIcons(list.type)
                                        })}
                                        sx={{
                                            cursor: "pointer",
                                            ':hover': {
                                                opacity: .8,
                                                color: renderPattern(list.type).renderColor(),
                                                backgroundColor: renderPattern(list.type).renderBackgroundColor(),
                                            },
                                            px: list.disabledPadding ? undefined : 2,
                                            textTransform: "none",
                                            height: '100%',
                                            boxShadow: !list.disabledTemplateBackground ? "0px 1px 3px 1px rgba(0,0,0,.10)" : undefined,
                                            backgroundColor: !list.disabledTemplateBackground ? renderPattern(list.type).renderBackgroundColor() : undefined,
                                            border: !list.disabledTemplateBorder ? renderPattern(list.type).renderBorder() : undefined,
                                            width: list.width,
                                            maxWidth: list.maxWidth,
                                        }}
                                    >
                                        <Typography sx={{
                                            fontSize: "16px",
                                            color: !list.disabledTemplateColor ? renderPattern(list.type).renderColor() : undefined,
                                        }} >
                                            {list.label}
                                        </Typography>
                                    </ButtonLayout>
                                )}

                            </span>
                        )
                    })
                }
            </div >
        </Box >
    )
}

export default ContainerButton